import { Checkbox, Color, Flex, Icon, IconButton, IconName, Spacing, Text } from '@billy/design-system'
import { ChangeEvent, MouseEvent, ReactElement } from 'react'

import { useSandboxModeContext } from '../../../../../contexts'
import { SandboxBlockedTooltip } from '../../../../SandboxBlockedTooltip'
import * as Styled from './styles'

export interface ListItemProps {
  description: string
  displayAmount: string
  date: string
  checked?: boolean
  icon?: IconName
  isOutlined?: boolean
  handleCheckboxChange?: (event: ChangeEvent<HTMLInputElement>) => void
  showCheckbox?: boolean
  viewUrl?: string
  footerContent?: ReactElement
}

export const ListItem = ({
  description,
  displayAmount,
  date,
  isOutlined = false,
  checked = false,
  handleCheckboxChange,
  icon,
  showCheckbox = false,
  viewUrl,
  footerContent,
}: ListItemProps): ReactElement => {
  const isSandboxMode = !!useSandboxModeContext()

  const handleViewClick = (event: MouseEvent) => {
    if (isSandboxMode) {
      event.preventDefault()
    }
  }

  return (
    <Styled.ItemWrapper isOutlined={isOutlined} hasFooterContent={!!footerContent}>
      <Flex flexDirection="column" gap={Spacing.S16}>
        <Flex alignItems="center" gap={Spacing.S6}>
          <Styled.ContentWrapper>
            {showCheckbox || !icon ? (
              <Flex alignItems="center" justifyContent="center">
                <Checkbox checked={checked} onChange={handleCheckboxChange} size="l" />
              </Flex>
            ) : (
              <Styled.IconWrapper>
                <Icon icon={icon} color={Color.Grey950} />
              </Styled.IconWrapper>
            )}
            <Styled.TextWrapper>
              <Text weight="medium">{description}</Text>
              <Flex gap={Spacing.S8}>
                <Text colorVariant="discreet" variant="bodySM" nowrap truncate>
                  {displayAmount}
                </Text>
                <Text colorVariant="discreet" variant="bodySM">
                  ·
                </Text>
                <Text colorVariant="discreet" variant="bodySM" truncate>
                  {date}
                </Text>
              </Flex>
            </Styled.TextWrapper>
          </Styled.ContentWrapper>
          {viewUrl && (
            <SandboxBlockedTooltip>
              <IconButton
                as="a"
                href={viewUrl}
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleViewClick}
                icon={<Icon icon="eye" size="md" color="currentColor" />}
                variant="text"
              />
            </SandboxBlockedTooltip>
          )}
        </Flex>
        {footerContent}
      </Flex>
    </Styled.ItemWrapper>
  )
}
